import { useState, useEffect } from "react";
import InputTag from "../InputTag/InputTag";
import deleteIcon from "../../../../../assets/img/delete-icon.svg";
import addIcon from "../../../../../assets/img/addicon.svg";
import { Spinner } from "react-bootstrap";

const InputVariation = ({
  titleVariation,
  tagsVariation,
  getInputVariation,
  saveVariation,
  variationId,
  editVariation,
  setDeleteVariation,
  loadingVariation,
}) => {
  const [inputOpened, setInputOpened] = useState(false);
  const [title, setTitle] = useState(titleVariation);
  const [editTitle, setEditTitle] = useState(false);
  const [loader, setLoader] = useState(loadingVariation);
  useEffect(() => {
    setLoader(loadingVariation);
  }, [loadingVariation]);

  const getAndSetTitle = (event) => {
    event.preventDefault();
    if (event.type === "keyup") {
      if (event.key === "Enter") {
        const newTitle = event.target.value;
        setTitle(newTitle);
        editVariation(event.target.value, variationId);
        openEditTitle(false);
      }
    }
  };

  const openEditTitle = (value) => {
    setEditTitle(value);
    setTimeout(() => {
      const inputVariationtitle = document.getElementById("edit-variation-title");
      if (inputVariationtitle) inputVariationtitle.focus();
    }, 100);
  };

  const openInput = () => {
    setInputOpened(true);
    setTimeout(() => {
      const inputVariationtitle = document.getElementById("input-variation-title");
      if (inputVariationtitle) inputVariationtitle.focus();
    }, 100);
  };

  const inputTitle = (event) => {
    event.preventDefault();
    if (event.type === "keyup") {
      if (event.key === "Enter") {
        saveVariation(event.target.value);
        if (!title) {
          getInputVariation(true);
        } else {
          getInputVariation(false);
        }
        setInputOpened(false);
      }
    }
  };
  return (
    <>
      <div className="d-flex flex-column flex-lg-row mt-4">
        <div className="bg-cl-lightgray p-4 col-12 rounded-1 align-items-center">
          <div className="d-flex border-0 col-auto c-pointer align-items-center " onClick={() => openInput()}>
            {!title ? (
              <>
                {inputOpened ? (
                  <>
                    <input
                      onKeyUp={(event) => inputTitle(event)}
                      onBlur={() => setInputOpened(false)}
                      id="input-variation-title"
                      className="border-0 ff-univanova fz-16 c-pointer p-2 form-control bg-transparent text-cl-black-4 shadow-none fw-bold"
                    ></input>
                  </>
                ) : (
                  <>
                    {!loader ? (
                      <div className="border-0 ff-univanova fz-16 c-pointer p-2 form-control bg-transparent text-cl-black-4  d-flex align-items-center">
                        <img alt="delete variation" className="me-2" src={addIcon} />
                        <span>
                          Adicione e pressione <strong>Enter</strong> para adicionar uma nova variação
                        </span>
                      </div>
                    ) : (
                      <>
                        <div className="border-0 ff-univanova fz-16 c-pointer p-2 form-control bg-transparent text-cl-black-4  d-flex align-items-center">
                          <Spinner animation="border" role="status" className="me-3">
                            <span className="visually-hidden">Loading...</span>
                          </Spinner>
                          <span>Carregando variações</span>
                        </div>
                      </>
                    )}
                  </>
                )}
              </>
            ) : (
              <>
                <div className="col-12">
                  <div className="d-flex">
                    {!editTitle ? (
                      <div
                        className="mb-3 me-auto px-2 rounded-2 edit-input-variation"
                        onClick={() => openEditTitle(true)}
                      >
                        <span className="text-cl-black-4 ff-univanova fz-16 fw-bold">{titleVariation}</span>
                        <i class="ms-2 fz-13 bi bi-pencil-fill edit-icon-input-variation"></i>
                      </div>
                    ) : (
                      <div className="mb-3 me-auto px-2 rounded-2">
                        <input
                          id="edit-variation-title"
                          className="text-cl-black-4 ff-univanova fz-16 fw-bold form-control shadow-none m-0 p-0 border-0 bg-transparent"
                          defaultValue={titleVariation}
                          onKeyUp={(event) => getAndSetTitle(event)}
                          onBlur={() => openEditTitle(false)}
                        ></input>
                      </div>
                    )}
                    <div
                      className="d-flex mb-3 align-items-center variation-delete"
                      data-bs-toggle="modal"
                      data-bs-target="#confirmDeleteProduct"
                      onClick={() => setDeleteVariation(variationId)}
                    >
                      <div alt="delete variation" className="me-2 mb-1 variation-delete-image" />
                      <span className=" ff-univanova  fz-16">Excluir variação</span>
                    </div>
                  </div>
                  <div className="">
                    <InputTag
                      tagsVariation={tagsVariation}
                      editVariation={editVariation}
                      variationId={variationId}
                      titleVariation={titleVariation}
                    />
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default InputVariation;
